<template>
    <div id="log-in-page">

        <!-- White Box Section -->
        <section class="section-style margin-top-110">
            <div class="container padding-right-left-0">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <div class="box-form bg-white box-shadow">
                            <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Log in as existing customer</h1>
                            <component-login-form></component-login-form>
                            <div class="margin-top-20 margin-bottom-20">
                                <a href="" class="link-style d-block">Don’t you have an account? <i class="material-icons">keyboard_arrow_right</i></a>
                                <a href="" class="link-style d-block">Forgot password?<i class="material-icons">keyboard_arrow_right</i></a>
                            </div>
                            <div class="row">
                                <div class="col-12 margin-top-20">
                                    <button type="button" class="btn btn-primary btn-lg text-uppercase w-100">Log in with Facebook</button>
                                </div>
                                <div class="col-12 margin-top-10 margin-bottom-20">
                                    <button type="button" class="btn btn-danger btn-lg text-uppercase w-100">Log in with Google</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    export default {
        mounted() {

        }
    }

    /*new Vue({
        el: '#contact-us-page'
    });*/

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>
